import * as i0 from '@angular/core';
import { EventEmitter, Component, HostBinding, Input, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i3 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { __decorate } from 'tslib';
import * as i1 from '@slidebean/kappa';
import { css, Styled, KappaModule, IconsModule } from '@slidebean/kappa';
import { UIModule } from '@slidebean/ui';
import * as i2 from '@slidebean/ui/slide-properties-button';

var StrokeWidth;
(function (StrokeWidth) {
    StrokeWidth["Thin"] = "thin";
    StrokeWidth["Regular"] = "regular";
    StrokeWidth["Thick"] = "thick";
})(StrokeWidth || (StrokeWidth = {}));
function getStrokeWidthEm(stroke) {
    let strokeWidth = 0.4;
    switch (stroke) {
        case StrokeWidth.Thin: {
            strokeWidth = 0.1;
            break;
        }
        case StrokeWidth.Thick: {
            strokeWidth = 0.8;
            break;
        }
    }
    return strokeWidth;
}
function getStrokeDashArrayEm(stroke) {
    let strokeWidth = 0.7;
    switch (stroke) {
        case StrokeWidth.Thin: {
            strokeWidth = 0.3;
            break;
        }
        case StrokeWidth.Thick: {
            strokeWidth = 1.1;
            break;
        }
    }
    return strokeWidth;
}

const $StrokeStyleSelector = css({ display: 'block' });
let StrokeStyleSelectorComponent = class StrokeStyleSelectorComponent {
    constructor() {
        this.onSelect = new EventEmitter();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: StrokeStyleSelectorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.2", type: StrokeStyleSelectorComponent, selector: "sb-stroke-style-selector", inputs: { strokeStyle: "strokeStyle" }, outputs: { onSelect: "onSelect" }, host: { properties: { "class": "this.class" } }, ngImport: i0, template: `
    <kp-stack space="small">
      <kp-text-block size="small" weight="bold" tone="neutral">
        {{ 'Style' | translate }}
      </kp-text-block>

      <kp-set space="small">
        <button
          sb-slide-properties-button
          [active]="!strokeStyle || strokeStyle === 'solid'"
          (click)="onSelect.emit('solid')"
        >
          <kp-diagonal-solid-regular-line-icon />
        </button>

        <button
          sb-slide-properties-button
          [active]="strokeStyle === 'dashed'"
          (click)="onSelect.emit('dashed')"
        >
          <kp-diagonal-dashed-regular-line-icon />
        </button>
      </kp-set>
    </kp-stack>
  `, isInline: true, dependencies: [{ kind: "component", type: i1.TextBlockComponent, selector: "kp-text-block, div[kp-text-block], p[kp-text-block], a[kp-text-block]", inputs: ["tone", "weight", "size", "alignment", "contrast", "truncate", "clamp"] }, { kind: "directive", type: i1.TextBackgroundBehavior, selector: "kp-text, span[kp-text], a[kp-text], kp-text-block, div[kp-text-block], p[kp-text-block], a[kp-text-block]" }, { kind: "component", type: i1.SetComponent, selector: "kp-set", inputs: ["space", "alignmentX", "alignmentY", "collapseBelow", "wrap", "reverse", "grow"] }, { kind: "component", type: i1.StackComponent, selector: "kp-stack", inputs: ["space", "alignment", "grow"] }, { kind: "directive", type: i2.SlidePropertiesButtonDirective, selector: "button[sb-slide-properties-button]", inputs: ["active", "pill", "tone", "size"] }, { kind: "component", type: i1.DiagonalSolidRegularLineIconComponent, selector: "kp-diagonal-solid-regular-line-icon" }, { kind: "component", type: i1.DiagonalDashedRegularLineIconComponent, selector: "kp-diagonal-dashed-regular-line-icon" }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }] }); }
};
StrokeStyleSelectorComponent = __decorate([
    Styled($StrokeStyleSelector)
], StrokeStyleSelectorComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: StrokeStyleSelectorComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sb-stroke-style-selector',
                    template: `
    <kp-stack space="small">
      <kp-text-block size="small" weight="bold" tone="neutral">
        {{ 'Style' | translate }}
      </kp-text-block>

      <kp-set space="small">
        <button
          sb-slide-properties-button
          [active]="!strokeStyle || strokeStyle === 'solid'"
          (click)="onSelect.emit('solid')"
        >
          <kp-diagonal-solid-regular-line-icon />
        </button>

        <button
          sb-slide-properties-button
          [active]="strokeStyle === 'dashed'"
          (click)="onSelect.emit('dashed')"
        >
          <kp-diagonal-dashed-regular-line-icon />
        </button>
      </kp-set>
    </kp-stack>
  `,
                }]
        }], propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }], strokeStyle: [{
                type: Input
            }], onSelect: [{
                type: Output
            }] } });
const DIRECTIVES$1 = [StrokeStyleSelectorComponent];
class StrokeStyleSelectorModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: StrokeStyleSelectorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.2", ngImport: i0, type: StrokeStyleSelectorModule, declarations: [StrokeStyleSelectorComponent], imports: [CommonModule, KappaModule, UIModule, TranslateModule, IconsModule], exports: [StrokeStyleSelectorComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: StrokeStyleSelectorModule, imports: [CommonModule, KappaModule, UIModule, TranslateModule, IconsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: StrokeStyleSelectorModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, KappaModule, UIModule, TranslateModule, IconsModule],
                    declarations: DIRECTIVES$1,
                    exports: DIRECTIVES$1,
                }]
        }] });

const $StrokeWidthSelector = css({ display: 'block' });
let StrokeWidthSelectorComponent = class StrokeWidthSelectorComponent {
    constructor() {
        this.onSelect = new EventEmitter();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: StrokeWidthSelectorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.2", type: StrokeWidthSelectorComponent, selector: "sb-stroke-width-selector", inputs: { strokeWidth: "strokeWidth" }, outputs: { onSelect: "onSelect" }, host: { properties: { "class": "this.class" } }, ngImport: i0, template: `
    <kp-stack space="small">
      <kp-text-block size="small" weight="bold" tone="neutral">
        {{ 'Weight' | translate }}
      </kp-text-block>

      <kp-set space="small">
        <button
          sb-slide-properties-button
          [active]="strokeWidth === 'thin'"
          (click)="onSelect.emit('thin')"
        >
          <kp-diagonal-solid-thin-line-icon />
        </button>

        <button
          sb-slide-properties-button
          [active]="!strokeWidth || strokeWidth === 'regular'"
          (click)="onSelect.emit('regular')"
        >
          <kp-diagonal-solid-regular-line-icon />
        </button>

        <button
          sb-slide-properties-button
          [active]="strokeWidth === 'thick'"
          (click)="onSelect.emit('thick')"
        >
          <kp-diagonal-solid-thick-line-icon />
        </button>
      </kp-set>
    </kp-stack>
  `, isInline: true, dependencies: [{ kind: "component", type: i1.TextBlockComponent, selector: "kp-text-block, div[kp-text-block], p[kp-text-block], a[kp-text-block]", inputs: ["tone", "weight", "size", "alignment", "contrast", "truncate", "clamp"] }, { kind: "directive", type: i1.TextBackgroundBehavior, selector: "kp-text, span[kp-text], a[kp-text], kp-text-block, div[kp-text-block], p[kp-text-block], a[kp-text-block]" }, { kind: "component", type: i1.SetComponent, selector: "kp-set", inputs: ["space", "alignmentX", "alignmentY", "collapseBelow", "wrap", "reverse", "grow"] }, { kind: "component", type: i1.StackComponent, selector: "kp-stack", inputs: ["space", "alignment", "grow"] }, { kind: "directive", type: i2.SlidePropertiesButtonDirective, selector: "button[sb-slide-properties-button]", inputs: ["active", "pill", "tone", "size"] }, { kind: "component", type: i1.DiagonalSolidRegularLineIconComponent, selector: "kp-diagonal-solid-regular-line-icon" }, { kind: "component", type: i1.DiagonalSolidThinLineIconComponent, selector: "kp-diagonal-solid-thin-line-icon" }, { kind: "component", type: i1.DiagonalSolidThickLineIconComponent, selector: "kp-diagonal-solid-thick-line-icon" }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }] }); }
};
StrokeWidthSelectorComponent = __decorate([
    Styled($StrokeWidthSelector)
], StrokeWidthSelectorComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: StrokeWidthSelectorComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sb-stroke-width-selector',
                    template: `
    <kp-stack space="small">
      <kp-text-block size="small" weight="bold" tone="neutral">
        {{ 'Weight' | translate }}
      </kp-text-block>

      <kp-set space="small">
        <button
          sb-slide-properties-button
          [active]="strokeWidth === 'thin'"
          (click)="onSelect.emit('thin')"
        >
          <kp-diagonal-solid-thin-line-icon />
        </button>

        <button
          sb-slide-properties-button
          [active]="!strokeWidth || strokeWidth === 'regular'"
          (click)="onSelect.emit('regular')"
        >
          <kp-diagonal-solid-regular-line-icon />
        </button>

        <button
          sb-slide-properties-button
          [active]="strokeWidth === 'thick'"
          (click)="onSelect.emit('thick')"
        >
          <kp-diagonal-solid-thick-line-icon />
        </button>
      </kp-set>
    </kp-stack>
  `,
                }]
        }], propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }], strokeWidth: [{
                type: Input
            }], onSelect: [{
                type: Output
            }] } });
const DIRECTIVES = [StrokeWidthSelectorComponent];
class StrokeWidthSelectorModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: StrokeWidthSelectorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.2", ngImport: i0, type: StrokeWidthSelectorModule, declarations: [StrokeWidthSelectorComponent], imports: [CommonModule, KappaModule, UIModule, TranslateModule, IconsModule], exports: [StrokeWidthSelectorComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: StrokeWidthSelectorModule, imports: [CommonModule, KappaModule, UIModule, TranslateModule, IconsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: StrokeWidthSelectorModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, KappaModule, UIModule, TranslateModule, IconsModule],
                    declarations: DIRECTIVES,
                    exports: DIRECTIVES,
                }]
        }] });

class ShapeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: ShapeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.2", ngImport: i0, type: ShapeModule, imports: [CommonModule, TranslateModule], exports: [StrokeStyleSelectorModule, StrokeWidthSelectorModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: ShapeModule, imports: [CommonModule, TranslateModule, StrokeStyleSelectorModule, StrokeWidthSelectorModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.2", ngImport: i0, type: ShapeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, TranslateModule],
                    exports: [StrokeStyleSelectorModule, StrokeWidthSelectorModule],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ShapeModule, StrokeStyleSelectorComponent, StrokeStyleSelectorModule, StrokeWidth, StrokeWidthSelectorComponent, StrokeWidthSelectorModule, getStrokeDashArrayEm, getStrokeWidthEm };
